import React from 'react';
import { Row, Col, Image, Space, Typography, Card, Grid } from 'antd';
import Img1 from '../../assets/img/chen.jpg';
import Img2 from '../../assets/img/vidhya.jpg';
import Img3 from '../../assets/img/ikenna.jpg';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Speakers() {
  const { xs, xxl } = useBreakpoint()
  return (
    <React.Fragment>
      {
        xs ?
          <Row justify="space-around" align="middle" gutter={[0,16]} style={{ backgroundColor: '#F2F2F2', padding: 16, textAlign: 'center' }}>
            <Col span={24} style={{ paddingBottom: 32 }}>
              <Text style={{ fontSize: 22, fontWeight: 'bold' }}>Invited Speakers</Text>
            </Col>
            <Col span={24}>
              <Card style={{ width: '100%', borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={'50%'}
                    src={Img1}
                    preview={false}
                    style={{ objectFit: 'cover', borderRadius: 8 }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <Text style={{ fontSize: 15 }}>Prof. Jengchung Victor Chen*</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>National Cheng Kung University</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>Taiwan</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={24}>
              <Card style={{ width: '100%', borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={'50%'}
                    src={Img2}
                    preview={false}
                    style={{ objectFit: 'cover', borderRadius: 8 }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <Text style={{ fontSize: 15 }}>Prof. Vidhya Venugopal</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>Sri Ramachandra Institute of Higher Education and Research</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>India</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={24}>
              <Card style={{ width: '100%', borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={'50%'}
                    src={Img3}
                    preview={false}
                    style={{ objectFit: 'cover', borderRadius: 8 }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <Text style={{ fontSize: 15 }}>Prof. Dr. Ikenna Ebuenyi</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>University of Pittsburgh</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>USA</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
          </Row>
        :
          <Row justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#F2F2F2', padding: xxl ? '50px 300px 70px 300px' : '50px 50px 70px 50px', textAlign: 'center' }}>
            <Col span={24} style={{ paddingBottom: 64 }}>
              <Text style={{ fontSize: 30, fontWeight: 'bold' }}>Invited Speakers</Text>
            </Col>
            <Col span={8}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={'50%'}
                    src={Img1}
                    preview={false}
                    style={{ objectFit: 'cover', borderRadius: 8 }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <Text style={{ fontSize: 15 }}>Prof. Jengchung Victor Chen*</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>National Cheng Kung University</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>Taiwan</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={8}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={'50%'}
                    src={Img2}
                    preview={false}
                    style={{ objectFit: 'cover', borderRadius: 8 }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <Text style={{ fontSize: 15 }}>Prof. Vidhya Venugopal</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>Sri Ramachandra Institute of Higher Education and Research</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>India</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={8}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={'50%'}
                    src={Img3}
                    preview={false}
                    style={{ objectFit: 'cover', borderRadius: 8 }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <Text style={{ fontSize: 15 }}>Prof. Dr. Ikenna Ebuenyi</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>University of Pittsburgh</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>USA</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Speakers